import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id B4B33DFC-4361-478D-A3A3-3FD224B95C16
 * name download-circle
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/download-circle.svg
 * tags
 */
export const DownloadCircleIcon = createSvgIcon(<><path d="M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M8 17H16V15H8V17M16 10H13.5V6H10.5V10H8L12 14L16 10Z" /></>, 'DownloadCircleIcon');
export default DownloadCircleIcon